import { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { Col, Tab, Tabs } from 'react-bootstrap';

//HOCs
import applicationRouter from '~/hoc/applicationRouter'
import withLocalization from '../../../hoc/withLocalization';

//elements
import LoadingSpinner from '~/elements/LoadingSpinner';
import DeviationUrgencyMarker from '../Deviation/DeviationUrgencyMarker';

const tabs = [
    {
        id: 'newDeviations',
        title: 'New to assign',
        filter: 'last',
    },
    {
        id: 'toApprove',
        title: 'Waiting for approval',
        filter: 'complete',
    },
    {
        id: 'reportedByYou',
        title: 'Reported by me',
        filter: 'assigned_by_me',
    },
    {
        id: 'yourDeviations',
        title: 'Assigned to me',
        filter: 'assigned_to_me',
    },
];

class DeviationWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deviations: {
                yourDeviations: [],
                reportedByYou: [],
                newDeviations: [],
                toApprove: [],
            },
            isLoading: true
        };
    }

    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        const { commonStore, dashboardStore, t } = this.props;
        try {
            const deviations = await dashboardStore.getDeviations();
            this.setState({ deviations, isLoading: false });

        } catch (error) {
            console.error(error);
            commonStore.addNotification(t(error.message || "Something went wrong"), null, 'error');
            this.setState({ isLoading: false });
        }
    }


    renderSingleList(data, title, filter, userId) {
        const { commonStore } = this.props;
        const deviationConfig = commonStore?.config?.deviationConfig || {};
        let searchQuery = '?';
        if (filter === 'assigned_to_me') {
            searchQuery += `assigned_id=${userId}&`;
        }
        if (filter === 'assigned_by_me') {
            searchQuery += `reported_by_id=${userId}&`;
        }
        if (filter === 'complete') {
            searchQuery += `status=${userId}&`;
        }
        const { t } = this.props;
        if (!data || data.length === 0)
            return <span className='d-flex justify-content-center mt-1 w-100 fw-bold'
                style={{ color: "#B2B7B2" }}>
                {t("No data found")}
            </span>;
        return (
            <>
                <div className="horizontal-scroll">
                    <table className="table table-project-small mt-0">
                        <thead>
                            <tr>
                                <th className="text-center">ID</th>
                                <th>{t('Project')}</th>
                                <th>{t('Subject')}</th>
                                <th>{t('Reported by')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map(row => (
                                <tr key={row.id}>
                                    <td className="d-flex justify-content-center align-items-center ">
                                        <DeviationUrgencyMarker config={deviationConfig} t={t} urgency={row.urgency} />

                                        <NavLink to={`/admin/deviation/${row.id}`}>{row.id}</NavLink>
                                    </td>
                                    <td>{row.project_name}</td>
                                    <td>{row.subject}</td>
                                    <td>{row.reporter_name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <h6 className='mt-2'>
                    <NavLink
                        to={{
                            pathname: '/admin/deviation/',
                            search: searchQuery,
                        }}
                    >
                        {t('View all')}: {title}
                    </NavLink>
                </h6>
            </>
        );
    }

    getTitle(tab, deviations) {
        const { t } = this.props;
        try {
            return `${t(tab.title)} (${deviations[tab.id].length || 0})`;
        }
        catch (err) {
            return `${t(tab.title)} (0), ${err}, deviations: ${(Object.keys(deviations).toString())}`;
        }
    }

    render() {
        const { deviations, isLoading } = this.state;
        if (isLoading)
            return <LoadingSpinner />

        const { t, userStore } = this.props;
        const { id: userId, user_type: userType } = userStore.currentUser;
        let filteredTabs = tabs;
        if (userType === 'member') {
            filteredTabs = tabs.filter(tab => tab.id === 'reportedByYou' || tab.id === 'yourDeviations');
        }

        return (
            <Fragment>
                <Col sm={12} lg={12}>
                    <h4 className="card-title">
                        <NavLink to="/admin/deviation" className="dashboard-nav-link mx-2 mx-md-none">{t('Deviations')}</NavLink>
                    </h4>
                    <div className="dashboard-tabs-container mt-2">
                        <Tabs defaultActiveKey={filteredTabs[0].id} id="tabs">
                            {filteredTabs.map(tab => (
                                <Tab eventKey={tab.id} title={this.getTitle(tab, deviations)} key={tab.id}>
                                    {this.renderSingleList(deviations[tab.id], t(tab.title), tab.filter, userId)}
                                </Tab>
                            ))}
                        </Tabs>
                    </div>
                </Col>
            </Fragment>
        );
    }
}

export default inject('dashboardStore', 'commonStore', 'userStore')(applicationRouter(withLocalization(observer(DeviationWidget))));
